export default "__VITE_ASSET__voU0jWOf__"